const StartChatBtn = ({ text = "start chat", handleStartChat }) => <button 
  onClick={handleStartChat} 
  className="rounded-full px-8 py-4 sm:py-2 bg-[#FF7A1A] text-white capitalize text-lg font-semibold w-[55vw] sm:w-fit"
  >
    {text}
  </button>

export default StartChatBtn;